import { render, staticRenderFns } from "./Catalogue.vue?vue&type=template&id=9fa7302e&"
import script from "./Catalogue.vue?vue&type=script&lang=js&"
export * from "./Catalogue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\immersive\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fa7302e')) {
      api.createRecord('9fa7302e', component.options)
    } else {
      api.reload('9fa7302e', component.options)
    }
    module.hot.accept("./Catalogue.vue?vue&type=template&id=9fa7302e&", function () {
      api.rerender('9fa7302e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Catalogue.vue"
export default component.exports